import {
  StyleParamType,
  wixColorParam,
  wixFontParam,
  createStylesParams,
} from '@wix/tpa-settings';
import {
  StyleType,
  wixColor,
  wixFont,
} from '@wix/editor-platform-ooi-metadata-resolver';

// Cast needed: tpa-settings and editor-platform-ooi-metadata-resolver can resolve to different
// package versions in the monorepo, so StyleType / StyleTypeMetadata may not match.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const asMetadata = (m: object): any => m;

export type IStylesParams = {
  backgroundColor: StyleParamType.Color;
  borderColor: StyleParamType.Color;
  titleFont: StyleParamType.Font;
  primaryFont: StyleParamType.Font;
  textColor: StyleParamType.Color;
  indicatorColor: StyleParamType.Color;
  borderWith: StyleParamType.Number; // the typo is intended :(
};

export default createStylesParams<IStylesParams>({
  backgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: asMetadata({
      type: StyleType.backgroundColor,
      defaultValue: wixColor('wst-primary-background-color'),
    }),
  },
  borderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2', 0.75),
    metadata: asMetadata({
      type: StyleType.borderColor,
      defaultValue: wixColor('wst-button-secondary-color', 0.75),
    }),
  },
  titleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Heading-M', {
      size: 26,
    }),
    metadata: asMetadata({
      type: StyleType.font,
      defaultValue: wixFont('wst-heading-5-font'),
    }),
  },
  primaryFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 14,
    }),
    metadata: asMetadata({
      type: StyleType.font,
      defaultValue: wixFont('wst-paragraph-2-font'),
    }),
  },
  textColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: asMetadata({
      type: StyleType.color,
      defaultValue: wixColor('wst-paragraph-2-color'),
    }),
  },
  indicatorColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: asMetadata({
      type: StyleType.color,
      defaultValue: wixColor('wst-links-and-actions-color'),
    }),
  },
  borderWith: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: asMetadata({
      type: StyleType.borderWidth,
      defaultValue: { type: 'static', value: 0 },
    }),
  },
});
